import React from "react";
import ReactECharts from "echarts-for-react";
import { Card, Typography, makeStyles } from "@material-ui/core";
import { getRandomColor } from "../../../Utilities/Functions";
import styles from "./styles";

const useStyles = makeStyles(styles);

const Pie = (props) => {
  const classes = useStyles();

  const {
    title,
    subTitle,
    data,
    showTooltip,
    showLegend,
    width,
    height,
  } = props;

  const options = {
    tooltip: {
      show: showTooltip || false,
    },
    legend: {
      show: showLegend || false,
      bottom: true,
    },
    series: [
      {
        name: "Text",
        type: "pie",
        radius: ["55%", "70%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "10",
            formatter: "{b}: {c}",
          },
        },
        labelLine: {
          show: false,
        },
        data: (data || []).map((item) => ({
          value: item.value,
          name: item.name,
          itemStyle: { color: item.color || getRandomColor() },
        })),
      },
    ],
  };

  return (
    <Card
      className={classes.container}
      variant="outlined"
      elevation={0}
      style={{ width }}
    >
      <ReactECharts style={{ height }} option={options} />
      <Typography
        style={{
          textAlign: "center",
          fontSize: "2.7rem",
          fontWeight: 300,
          lineHeight: 1,
        }}
        component={"h2"}
        component={"h2"}
      >
        {subTitle}
      </Typography>
      {title && (
        <Typography style={{ textAlign: "center", fontSize: "1.1rem" }}>
          {title}
        </Typography>
      )}
    </Card>
  );
};

export default Pie;
